var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('SplashScreen',{attrs:{"value":_vm.isFetchingAuth}}),(!_vm.isFetchingAuth)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }